
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CardBody from '@/components/card-body/index.vue'
import Lookup from '@/entities/lookup'

@Component({
  components: { CardBody }
})
export default class LookupEdit extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'Lookup Edit'

  lookup: Lookup = new Lookup()

  rules = {
    source: [
      {
        required: true,
        message: 'Please input Source',
        trigger: 'blur'
      }
    ],
    text: [
      {
        required: true,
        message: 'Please input Text',
        trigger: 'blur'
      }
    ],
    description: [
      {
        required: true,
        message: 'Please input Description',
        trigger: 'blur'
      }
    ],
    lookupType: [
      {
        required: true,
        message: 'Please input LookupType',
        trigger: 'blur'
      }
    ],
    sequence: [
      {
        required: true,
        message: 'Please input Sequence',
        trigger: 'change'
      }
    ]
  }

  // 新建或更新
  doCreateOrUpdate() {
    ;(this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      this.createOrUpdateLookup({
        lookup: this.lookup
      })
    })
  }
  // 调用接口
  async createOrUpdateLookup(data) {
    await this.$store.dispatch({
      type: 'lookup/createOrUpdateLookup',
      data: data
    })
    this.$notify.success({
      title: 'Success',
      message: 'Save Success'
    })
    this.doCancel()
  }

  doCancel() {
    ;(this.$refs.form as any).resetFields()
    this.$router.back()
  }

  loading = false

  async created() {
    try {
      this.loading = true
      let id = +this.$route.params.id
      if (!id || id < 0) {
        // 新增
        return
      }
      // 编辑
      this.$set(this.lookup, 'id', +id)
      let res = await this.$store.dispatch({
        type: 'lookup/get',
        id: this.$route.params.id
      })
      this.lookup = res.lookUp
    } catch (e) {
      console.log(e);
    } finally{
      this.loading = false
    }
  }
}
